import $http from '../../../axios-intance';
import {Notification} from 'element-ui';

export async function fetchBanner({dispatch, state, rootState, commit}, requestParameters = {params: state.params}) {
    if (!state.banners.length) {

        requestParameters.params.lines = rootState.login.user_b2b.line.line.line_code;
        requestParameters.params.contact_id = rootState.login.user_b2b.contact_id;

        await dispatch('bannerB2b/listBanner', requestParameters /* {params:{idParameter:19, idLine:21}} */, {root: true});
        commit('setBanners', rootState.bannerB2b.banners);
    }
}

export async function fetchBrand({dispatch, state, rootState, commit}) {
    let user_b2b = rootState.login.user_b2b;

    let params = {
        paginate: false,
        lines: [user_b2b.line.line.line_code],
        warehouse_id: user_b2b.id
    }

    await dispatch('brands/fetchBrands', {params}, {root: true});

    if (!!rootState.brands.brands.length) {

        let brands = rootState.brands.brands;

        brands = brands.concat(brands)
        brands = brands.concat(brands)

        commit('setBrands', brands);
    }
}

export async function fetchPromotions({dispatch, state, rootState, commit}) {

    let requestParameters = {
        params: {
            contact_warehouse_id: rootState.login.user_b2b.id,
            price_list_id: rootState.login.user_b2b.price_list_id
        }
    };

    await $http.get(`/api/productos-promociones`, requestParameters)
        .then((response) => {
            commit('setProds', response.data.data);
        })
        .catch((error) => {

        });
}

export async function fetchSalesBudgets({dispatch, state, rootState, commit}, params) {
    // Se consulta al abrir el modal. Por defecto se enviará la sucursal actual del usuario.
    // Params esperados: { seller_id, contact_warehouse_id? , contact_id? }
    const payload = Object.assign({}, params);
    await $http.post(`/api/presupuesto-de-ventas`, payload)
        .then((response) => {
            commit('setSalesBudgetShow', response.data);
        })
        .catch((error) => {
            // opcional: notificar
        });
}

export async function calculatePromotions({commit, state, rootState}) {

    let contact_warehouse_id = rootState.login.user_b2b.id;

    await $http.get('/api/calcular-promociones/' + contact_warehouse_id);
}

export async function fetchLinesCustomers({dispatch, state, rootState, commit}) {
    if (!state.lines_customers.length) {
        await dispatch('lines/fetchLines', {params: {idParamTable: 1, type_line: 'C', paginate: false}}, {root: true});
        commit('setLinesCustomers', rootState.lines.lines);
    }
}

export async function fetchLinesProducts({dispatch, state, rootState, commit}) {
    if (!state.lines_products.length) {
        await dispatch('lines/fetchLines', {params: {idParamTable: 1, type_line: 'P', paginate: false}}, {root: true});
        commit('setLinesProducts', rootState.lines.lines);
    }
}

/**
 * Obtener las línes de productos con base en la línea de sucursales.
 *
 * @param lineCode Código de la línea de sucursales
 * @returns {*[]}
 */
export async function getLinesProductsByLineCodeWarehouses({}, lineCode) {
    return await new Promise((resolve) => {
        const linesMap = {
            '50': ['AU01'],
            '52': ['AU01', 'CO01'],
            '60': ['AU01', 'CO01', 'MO01'],
            '62': ['AU01', 'CO01', 'MO01', 'NA01'],
            '58': ['NA01'],
            '55': ['CO01'],
            '57': ['AU01', 'CO01', 'NA01'],
            '70': ['MO01'],
            '71': ['MO01', 'NA01'],
            '80': ['BI01']
        };

        resolve(linesMap[lineCode] || []);
    });
}
